import {useId, useRef} from 'react';

import PopupFullPage from '@/components/Popup/PopupFullPage/PopupFullPage';
import usePopupRoute from '@/hooks/usePopupRoute';
import type {Badge} from '@/types/loyalty';

import BadgeDetailContent from './BadgeDetailContent';

type BadgeDetailDrawerProps = {
    badge: Badge | null;
    open: boolean;
    onClose: () => void;
};

const BadgeDetailDrawer = ({badge, open, onClose}: BadgeDetailDrawerProps) => {
    const titleId = useId();
    const lastBadgeRef = useRef<Badge | null>(null);
    const {onClose: handleClose} = usePopupRoute({popupKey: 'badge-detail', open, onClose});

    // Keep the last badge visible during close animation
    if (badge) {
        lastBadgeRef.current = badge;
    }

    const displayBadge = badge ?? lastBadgeRef.current;

    return (
        <PopupFullPage
            animateFromBottom
            className='bg-secondary'
            open={open}
            onOpenChange={(isOpen) => !isOpen && handleClose()}
            showCloseButton
            aria-labelledby={titleId}
        >
            {displayBadge && <BadgeDetailContent badge={displayBadge} titleId={titleId} />}
        </PopupFullPage>
    );
};

export default BadgeDetailDrawer;
